/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OccupancyResponseDto
 */
export interface OccupancyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OccupancyResponseDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OccupancyResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the OccupancyResponseDto interface.
 */
export function instanceOfOccupancyResponseDto(value: object): value is OccupancyResponseDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function OccupancyResponseDtoFromJSON(json: any): OccupancyResponseDto {
    return OccupancyResponseDtoFromJSONTyped(json, false);
}

export function OccupancyResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OccupancyResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isActive': json['isActive'],
    };
}

export function OccupancyResponseDtoToJSON(json: any): OccupancyResponseDto {
    return OccupancyResponseDtoToJSONTyped(json, false);
}

export function OccupancyResponseDtoToJSONTyped(value?: OccupancyResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isActive': value['isActive'],
    };
}

